import { setAssetsRegistry } from "@nectary/assets/utils";
import { setNectaryRegistry } from "@nectary/components/utils";
import { setSkeletonRegistry } from "@sinch/shell-skeleton";

function setupComponents(customElementRegistry: CustomElementRegistry) {
  setNectaryRegistry(customElementRegistry);
}

function setupAssets(customElementRegistry: CustomElementRegistry) {
  setAssetsRegistry(customElementRegistry);
}

function setupSkeleton(customElementRegistry: CustomElementRegistry) {
  setSkeletonRegistry(customElementRegistry);
}

export function setupNectary(registry: CustomElementRegistry): void {
  setupAssets(registry);
  setupComponents(registry);
  setupSkeleton(registry);
}
